import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, useMediaQuery } from '@material-ui/core'
import { SimpleLoading } from '../../pures'
import {
  ButtonAddHLPure,
  DropDownBtnHLPure,
  GridHLPure,
  SearchBarHLPure,
} from '../../pures'
import './digital-contract-template.css'
import { disable, bussiness, iconTemplateSet, iconTemplateUnset } from '../../../assets/logos/icons'
import TemplatesConfigurationsView from './digital-contract-template-pages/digital-contract-template-configuration.view'
import { TemplateValidator } from '../../../validators'
import { NIL as NIL_UUID } from 'uuid'

const DigitalContractTemplatesView = (props) => {
  const { clientTemplates,
    companies,
    clientId,
    formatVariables,
    getTemplatebyPath,
    history,
  } = props
  const { t } = useTranslation()

  const hideCharacteristics = useMediaQuery('(max-width: 860px)')

  const [templates, setTemplates] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [selectedValueFilter, setSelectedValue] = useState(NIL_UUID)
  const [selectedTemplate, setSelecteTemplate] = useState({})
  const [showDetails, setShowDetails] = useState(false)
  const [nameComponentTemplate, setNameComponentTemplate] = useState('')
  const [headerTitleinDetail, setHeaderTitleinDetail] = useState({
    clicked: false,
    name: '',
  })

  const validators = TemplateValidator(t)
  //Update state information from grid
  useEffect(() => {
    if (!clientTemplates) return
    let templateCopy = [...clientTemplates]
    let dataUpdateFilter = templateCopy.filter(
      (template) => template.companyId === selectedValueFilter && template.active === true
    )

    setTemplates(dataUpdateFilter)
  }, [clientTemplates])


  const strToboolean = (value) => {
    if (value && typeof value === 'string') {
      if (value.toLowerCase() === 'true') return true
      if (value.toLowerCase() === 'false') return false
    }
    if (value === 0) value = null
    if (value === '0') value = null
    return value
  }

  //Filter Function, get selected value
  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value)
    setSelectedValue(selectedOption)
  }

  //Search Function, get value search input
  const searchChange = (e) => {
    setSearchValue(e.target.value)
  }

  //Search Function, search elements and update grid
  useEffect(() => {
    let templateCopy = [...clientTemplates]
    let dataUpdateFilter = null
    if (!selectedValueFilter) {
      dataUpdateFilter = clientTemplates
    } else if (selectedValueFilter === '1') {
      dataUpdateFilter = templateCopy.filter(
        (template) => template.companyId === null && template.clientId == null && template.active === true
      )
    } else {
      dataUpdateFilter = templateCopy.filter(
        (template) => template.companyId === selectedValueFilter && template.active === true
      )
    }

    let dataUpdateSearch = dataUpdateFilter.filter((template) => {
      return (
        // template.description.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0 ||
        template.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
      )
    })

    setTemplates(dataUpdateSearch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, selectedValueFilter])

  const setHeaderTitle = () => {
    const name = headerTitleinDetail.name || nameComponentTemplate
    switch (name) {
      case '':
        return t('digitalContractTemplates.title')
      case t('digitalContractDashboard.templates.routerAdd'):
        return t('digitalContractTemplates.titleNewTemplate')
      case t('procedureAdministrationView.details'):
        return t('digitalContractTemplates.title')
      case 'Variables':
        return t('digitalContractTemplates.titleVariables')
      case t('digitalContractDashboard.templates.routerDisable'):
        return t('digitalContractTemplates.titleDelete') + selectedTemplate.name
      default:
        return t('digitalContractTemplates.title')
    }
  }

  useEffect(() => {
    if (headerTitleinDetail.clicked) {
      setHeaderTitle()
    }
    setHeaderTitle()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentTemplate, headerTitleinDetail])


  return (
    <div className='digitalVaul-templates-wrapper'>
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Grid>
          {/**Container para los items**/}
          <Grid className='digitalContractTemplates-body'>
            {/*Container primera seccion de items, fila*/}
            {showDetails && nameComponentTemplate ? (
              <TemplatesConfigurationsView
                nameComponentTemplate={nameComponentTemplate}
                selectedTemplate={selectedTemplate}
                hideShowDetails={() => {
                  setShowDetails(false)
                  setNameComponentTemplate('')
                  setHeaderTitleinDetail({ clicked: false, name: '' })
                  setSearchValue('')
                }}
                token={props.token}
                options={companies}
                clientId={clientId}
                setHeaderTitleinDetail={setHeaderTitleinDetail}
                formatVariables={formatVariables}
                validators={validators}
                forceRefresh={props.forceRefresh}
                getVariablesFromDoc={props.getVariablesFromDoc}
                getTemplatebyPath={getTemplatebyPath}
                showLoadingRequesting={props.showLoadingRequesting}
                showCompletedRequesting={props.showCompletedRequesting}
                message={props.message}
                showErrorRequesting={props.showErrorRequesting}
                toggleLoadingRequesting={props.toggleLoadingRequesting}
                toggleCompletedRequesting={props.toggleCompletedRequesting}
                toggleErrorRequesting={props.toggleErrorRequesting}
                clientTemplates={clientTemplates}
                selectedCompany={selectedValueFilter}
                history={history}
              />
            ) : (
              <>
                <div className='digitalContractTemplates-navbar'>
                  <ButtonAddHLPure
                    nameBtn={t('digitalContractTemlates.addNew')}
                    style={selectedValueFilter === '1' ? { visibility: 'hidden' } : null}
                    onClickBtn={() => {
                      if (selectedValueFilter === '1') return
                      setNameComponentTemplate(t('digitalContractDashboard.templates.routerAdd'))
                      setShowDetails(true)
                    }}
                    iconAdd={true}
                  />

                  <SearchBarHLPure
                    placeholder={t('digitalContractTemlates.searchTemplate')}
                    onSearchChange={(e) => searchChange(e)}
                    searchValue={searchValue}
                  />
                  <DropDownBtnHLPure
                    optionsDropDown={companies}
                    nameOption='companyName'
                    valueItem='id'
                    onDropDownChange={(event) => filterChange(event)}
                    optionsValue={selectedValueFilter}
                  />
                </div>

                <Grid
                  item
                  className='digitalContractTemplates-gridContainer'>
                  <GridHLPure
                    dataGrid={templates}
                    skip={0}
                    take={6}
                    titleRow1={t('digitalContractTemlates.titleGrid1')}
                    titleRow3={t('digitalContractTemlates.titleGrid2')}
                    titleRow4={t('digitalContractTemlates.titleGrid3')}
                    fieldRow1={'name'}
                    fieldTitle={'name'}
                    fieldSubtitle={'updatedDate'}
                    textSubtitle={t('digitalContractTemlates.textSubtitleGrid')}
                    onFilterChange={filterChange}
                    status={'active'}
                    onSelectedItem={setSelecteTemplate}
                    setShowDetails={setShowDetails}
                    setNameComponentUser={setNameComponentTemplate}
                    filter={true}
                    iconOneActions={bussiness}
                    iconTwoActions={disable}
                    labelThirdActions={t('digitalVaultSearchView.grid.title.variables')}
                    labelFourthActions={t('procedureAdministrationView.details')}
                    column2Status={false}
                    columnThree={!hideCharacteristics}
                    columnFour={true}
                    iconColumnTwo={true}
                    iconActiveTwo={false}
                    iconColumnThree={true}
                    iconOptionOne={iconTemplateSet}
                    iconOptionThree={iconTemplateUnset}
                    iconOneActive={false}
                    iconStatus={'documentLoaded'}
                    iconTwoActive={false}
                    iconActiveThree={false}
                    iconThirdActive={true}
                    iconFourthActive={true}
                    iconAvatar={false}
                    styleCol1={'digitalContractTemplates-cellItemStyleCol1'}
                    styleCol3={'digitalContractTemplates-cellItemStyleCol3'}
                    styleCol4={'digitalContractTemplates-cellItemStyleCol4'}
                    widthHeader={'digitalContractTemplates-cellItemStyleCol1'}
                    widthHeaderCol3={'digitalContractTemplates-cellItemStyleCol3'}
                    widthHeaderCol4={'digitalContractTemplates-cellItemStyleCol4 digitalContractTemplates-headerCol4'}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      )
      }
    </div >
  )
}

export default DigitalContractTemplatesView